import React, { useEffect, useRef } from "react";
import {
  ArrayInput,
  ReferenceInput,
  SimpleFormIterator,
  required,
  AutocompleteInput,
  useSimpleFormIteratorItem,
  TextInput,
} from "react-admin";
import { Grid } from "@mui/material";
import { settings } from "app";
import { useFormContext, useWatch } from "react-hook-form";
import { BULGARIA_COUNTRY_ID, BusinessTripTypes, SETTLEMENT_WITH_AREA_QUERY } from "utils/constants";
import { administrationRequests } from "api/administrationApi";

const LocationRowItem = () => {
  const { index } = useSimpleFormIteratorItem();
  const { setValue, watch } = useFormContext();
  const countryId = watch(`locations.${index}.countryId`);
  const businessTripType = watch("businessTripType");
  const isDomestic = businessTripType === BusinessTripTypes.Internal;
  const isFirstRender = useRef(true);

  useEffect(() => {
    // Stamped on mount too — the row only mounts once the trip type is already chosen.
    if (isDomestic) setValue(`locations.${index}.countryId`, BULGARIA_COUNTRY_ID);
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    if (!isDomestic) setValue(`locations.${index}.countryId`, null);
    // The city inputs are hidden on a domestic trip, so a leftover value would be sent unseen.
    setValue(`locations.${index}.settlement`, null);
    setValue(`locations.${index}.settlementId`, null);
  }, [isDomestic, index, setValue]);

  const handleCountryChange = () => {
    setValue(`locations.${index}.settlement`, null);
    setValue(`locations.${index}.settlementId`, null);
  };

  const validateLocation = isDomestic ? undefined : required();

  return (
    <>
      <ReferenceInput
        source="countryId"
        reference={administrationRequests.getCountriesSelect()}
      >
        <AutocompleteInput
          label="Държава"
          optionText={record => `${record.nameBg}`}
          filterToQuery={q => (q?.length > 2 ? { name: q } : {})}
          validate={validateLocation}
          onChange={handleCountryChange}
        />
      </ReferenceInput>
      {countryId === BULGARIA_COUNTRY_ID ? (
        <ReferenceInput
          source="settlementId"
          reference={administrationRequests.getSettlementsSelect()}
          queryOptions={{ meta: { query: SETTLEMENT_WITH_AREA_QUERY } }}
        >
          <AutocompleteInput
            label="Град"
            optionText={record => `${record.nameBg}`}
            filterToQuery={q => (q?.length > 2 ? { name: q } : {})}
            validate={validateLocation}
          />
        </ReferenceInput>
      ) : (
        <TextInput
          source="settlement"
          label="Град"
          validate={validateLocation}
        ></TextInput>
      )}
    </>
  );
};

// Kept mounted while hidden so a domestic trip still submits its Bulgaria-stamped location.
const LocationRow = () => {
  const businessTripType = useWatch({ name: "businessTripType" });
  const isDomestic = businessTripType === BusinessTripTypes.Internal;

  return (
    <Grid
      item
      xs={12}
      md={6}
      lg={6}
      sx={{ mt: 0, mb: 0, display: isDomestic ? "none" : undefined }}
    >
      <ArrayInput
        source="locations"
        label="Локации"
        defaultValue={[{}]}
      >
        <SimpleFormIterator sx={settings.style.iteratorWithoutGap}>
          <LocationRowItem />
        </SimpleFormIterator>
      </ArrayInput>
    </Grid>
  );
};

export default LocationRow;
